import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function DetailField({ label, value, children }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block">
        {label}
      </Typography>
      {children || (
        <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
          {value}
        </Typography>
      )}
    </Box>
  );
}
